var render, staticRenderFns
import script from "./DifferentFormTable.vue?vue&type=script&lang=js"
export * from "./DifferentFormTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('403e0afe')) {
      api.createRecord('403e0afe', component.options)
    } else {
      api.reload('403e0afe', component.options)
    }
    
  }
}
component.options.__file = "src/views/dms/views/new-column/column-l/form/DifferentFormTable.vue"
export default component.exports